import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import { push } from "react-router-redux";
import { setFeatures, setPermissions, clearFeaturesAndPermissions, setUserDetails, clearUserDetails } from '../_actions';
import { permissionService, tenantFeatureService, userService } from '../services'
import { USE_IDENTITY_SERVER } from "../_config";
import UserHelper from "../_helpers/UserHelper";

class CallbackPage extends React.Component {
    constructor(props){
        super(props);
        this.redirectSuccess = this.redirectSuccess.bind(this);
    }

    async redirectSuccess(){
        const self = this;
        self.props.dispatch(clearFeaturesAndPermissions());

        const userId = await UserHelper.getUserId();

        if (!USE_IDENTITY_SERVER) {
            userService.getUserDetails(userId).then(userDetails => {
                self.props.dispatch(setUserDetails(userDetails));
            });
        }

        permissionService.getPermissionsForCurrentUser()
            .then(data =>{
                self.props.dispatch(setPermissions(data));
                return tenantFeatureService.getTenantFeatures();
            })
            .then(data =>{
                self.props.dispatch(setFeatures(data.map(d => d.featureName)));
                self.props.dispatch(push("/"));
            })
            .catch((error) => {
                self.props.dispatch(clearFeaturesAndPermissions());
                if (!USE_IDENTITY_SERVER) {
                    self.props.dispatch(clearUserDetails());
                }
                self.props.dispatch(push("/"));
                console.error(error);
            });
    }

    render() {
        return (
            <CallbackComponent
                userManager={UserHelper.getUserManager()}
                successCallback={() => {
                    console.log('[Callback] successCallback fired');
                    this.redirectSuccess();
                }}
                errorCallback={error => {
                    console.error('[Callback] errorCallback', error);
                    try {
                        if (error) {
                            const msg = (error.message || '').substring(0, 500);
                            sessionStorage.setItem('auth_last_error', msg);
                            // Capture timestamp to allow future conditional retry logic
                            sessionStorage.setItem('auth_last_error_time', Date.now().toString());
                        }
                    } catch(e) { /* ignore storage issues */ }
                    this.props.dispatch(push("/auth-error"));
                }}>
                <div>Redirecting...</div>
            </CallbackComponent>
        );
    }
}

export default connect()(CallbackPage);
